import { cva } from "class-variance-authority";
//#region src/components/OverlayTrigger/styles.ts
/**
* Chrome for a control that looks like an input but opens an overlay on click. Shared by
* `SelectTrigger` and `DateRangePicker`'s trigger so both sit at the same height and colour when
* they stand next to each other in a filter row.
*/
const overlayTriggerVariants = cva([
	"tailwindcss-preflight",
	"tw:group",
	"tw:box-border",
	"tw:inline-flex",
	"tw:items-center",
	"tw:justify-between",
	"tw:gap-2",
	"tw:w-full",
	"tw:text-left",
	"tw:h-9",
	"tw:min-h-9",
	"tw:px-4",
	"tw:py-2",
	"tw:text-sm/[18px]",
	"tw:rounded-[var(--radius-lg,0.25rem)]",
	"tw:border",
	"tw:border-solid",
	"tw:border-input",
	"tw:bg-muted",
	"tw:text-foreground",
	"tw:transition-[color,background-color,border-color,box-shadow]",
	"tw:!outline-hidden",
	"tw:focus:ring-4",
	"tw:data-[state=open]:ring-4",
	"tw:disabled:cursor-not-allowed",
	"tw:aria-disabled:cursor-not-allowed",
	"tw:disabled:opacity-disabled",
	"tw:aria-disabled:opacity-disabled",
	"tw:aria-[invalid=true]:border-destructive",
	"tw:aria-[invalid=true]:focus:border-destructive",
	"tw:aria-[invalid=true]:focus:ring-destructive/20",
	"tw:aria-[invalid=true]:data-[state=open]:border-destructive",
	"tw:aria-[invalid=true]:data-[state=open]:ring-destructive/20",
	"tw:data-[placeholder]:text-muted-foreground",
	"tw:[&_svg]:shrink-0",
	"tw:[&_svg]:pointer-events-none"
], {
	defaultVariants: { state: "default" },
	variants: { state: {
		default: [
			"tw:focus:border-primary",
			"tw:focus:ring-ring/50",
			"tw:data-[state=open]:border-primary",
			"tw:data-[state=open]:ring-ring/50"
		],
		error: [
			"tw:border-destructive",
			"tw:focus:border-destructive",
			"tw:focus:ring-destructive/20",
			"tw:data-[state=open]:border-destructive",
			"tw:data-[state=open]:ring-destructive/20"
		],
		warning: [
			"tw:border-warning-500",
			"tw:focus:border-warning-500",
			"tw:focus:ring-warning/20",
			"tw:data-[state=open]:border-warning-500",
			"tw:data-[state=open]:ring-warning/20"
		]
	} }
});
//#endregion
export { overlayTriggerVariants };

//# sourceMappingURL=styles-T8xwr0sR.js.map